import React from 'react';

import { BackIcon, DownIcon, ForwardIcon, MicIcon, MicOffIcon, UpIcon } from './icons.js';

/**
 * Talk-down: the desk speaking through the speaker beside a camera. On,
 * it carries a live level meter, so it is obvious from across the room
 * that the microphone is open.
 */
export function TalkButton({ on, onClick, compact = false }) {
    return (
        <button
            type="button"
            className={`btn btn-sm cam-talk${on ? ' btn-primary cam-talk--on' : ' btn-outline-light'}`}
            aria-pressed={on}
            onClick={onClick}
        >
            {on ? <MicIcon aria-hidden="true" /> : <MicOffIcon aria-hidden="true" />}
            {compact ? (on ? 'Live' : 'Talk') : (on ? 'Speaking' : 'Talk-down')}
            {on && (
                <span className="cam-levels" aria-hidden="true">
                    <i /><i /><i /><i /><i />
                </span>
            )}
        </button>
    );
}

/**
 * The pan and tilt pad for a PTZ camera: four directions round a
 * centre that returns the camera to its home position. `readout` is the
 * position, shown beside it.
 */
export function PtzPad({ onMove, onHome, readout }) {
    return (
        <div className="cam-ptz" role="group" aria-label="Pan and tilt">
            <div className="cam-ptz__pad">
                <button type="button" className="cam-ptz__btn cam-ptz__btn--up" onClick={() => onMove(0, -1)} aria-label="Tilt up"><UpIcon aria-hidden="true" /></button>
                <button type="button" className="cam-ptz__btn cam-ptz__btn--left" onClick={() => onMove(-1, 0)} aria-label="Pan left"><BackIcon aria-hidden="true" /></button>
                <button type="button" className="cam-ptz__btn cam-ptz__btn--home" onClick={onHome} aria-label="Home position"><span /></button>
                <button type="button" className="cam-ptz__btn cam-ptz__btn--right" onClick={() => onMove(1, 0)} aria-label="Pan right"><ForwardIcon aria-hidden="true" /></button>
                <button type="button" className="cam-ptz__btn cam-ptz__btn--down" onClick={() => onMove(0, 1)} aria-label="Tilt down"><DownIcon aria-hidden="true" /></button>
            </div>
            {readout && <span className="cam-ptz__readout">{readout}</span>}
        </div>
    );
}
